import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Claims} from '../models/claims.model';

@Injectable()
export class ClaimsService {

    baseUrl = '/api/secured';

    constructor(private http: HttpClient) {
    }

    getInstallmentsAndClaims(policyId: number) {
        return this.http.get<Claims>(`${this.baseUrl}/policy/${policyId}/claims`);
    }

    getMigratedPolicyInstallmentsAndClaims(policyId: number) {
        return this.http.get<Claims>(`${this.baseUrl}/migrated/policy/${policyId}/claims`);
    }

    getRepositoryPolicyInstallmentsAndClaims(policyId: number) {
        return this.http.get<Claims>(`${this.baseUrl}/repository/${policyId}/claims`);
    }
}
